<div class="container-fluid banner_home pb-5">
  <app-header></app-header>

  <div class="container-fluid">
    <div class="container-home" style="max-width: 1318px; margin-inline: auto" id="addtestingforhomaepage">
      <div class="row home_banner">
        <div class="text-center">
          <h1 class="headFont">
            {{ "home.title" | translate }} {{ "home.title2" | translate }} <span class="greenF"> {{ "home.success" |
              translate }} </span>
          </h1>
          <p class="mb-3 headFontP">
            {{ "home.subtitle" | translate }} <br />
            {{ "home.subtitle2" | translate }}
          </p>
        </div>
        <div class="">
          <!-- <div class="bg_icons">
            <div class="text-field-back">
              <p
                class="text-left success-msg"
                *ngIf="got_recpatcha"
                [ngStyle]="{
                  color: color,
                  'background-color': '#f8d7da',
                  padding: '2px'
                }"
              >
                <i class="fa fa-times-circle matr ml-1" aria-hidden="true"></i>
                {{ recaptcha_message }}
              </p>
              <div class="text-field-home">
                <div class="text-field-home-top">
                  <div class="d-flex justC">
                    <button
                      class="marRi buton align-items-center justify-content-center d-flex uploadfile"
                      style="
                        display: flex !important;
                        flex-direction: row;
                        align-items: center;
                      "
                      value="Browse"
                      onclick="document.getElementById('upload').click();"
                    >
                      <app-icons-free-tools
                        name="laptopuploadhomeicon"
                        class="marRi"
                      />

                      <span class="upload-icon-text">
                        {{ "home.upload" | translate }}
                        <input
                          id="upload"
                          (change)="uploadFileSaveRedirect($event)"
                          data-name="upload-element"
                          #fileInput
                          accept=".txt,.doc,.docx,.pdf"
                          type="file"
                        />
                      </span>
                    </button>
                    <button
                      (click)="openDropboxChooser()"
                      class="buton align-items-center justify-content-center marRi google-icon-div"
                      style="
                        display: flex !important;
                        flex-direction: row;
                        align-items: center;
                      "
                    >
                      <app-icons-free-tools name="dropboxuploadhomeicon" />
                    </button>
                    <button
                      (click)="gDriveUpload()"
                      accept=".txt,.doc,.docx,.pdf"
                      class="buton d-flex align-items-center justify-content-center google-icon-div"
                      style="
                        display: flex !important;
                        flex-direction: row;
                        align-items: center;
                      "
                    >
                      <app-icons-free-tools name="googledriveuploadhomeicon" />
                    </button>
                  </div>
                  <div class="word-display">
                    <p class="word-font wordright">
                      {{ "home.words" | translate }}:
                      <span [ngClass]="{ 'break-line': iswordCountTooLarge() }">
                        {{ char_count === 0 ? 0 : word_count }}
                      </span>
                    </p>
                    &nbsp;
                    <p class="word-font word-display-mt">
                      {{ "home.character" | translate }}:
                      <span [ngClass]="{ 'break-line': isCharCountTooLarge() }">
                        {{ char_count }}</span
                      >
                    </p>
                  </div>
                </div>
                <label for="editor" class="d-none">ss</label>

                <quill-editor
                  class="home-editor new-quill-editor mt-2 px-3"
                  id="editor"
                  [modules]="editorModules"
                  [theme]="'snow'"
                  (onEditorCreated)="onEditorCreated($event)"
                  (blur)="onBlur()"
                  #text
                  [(ngModel)]="homeText"
                  placeholder=""
                  (onEditorCreated)="onHandleFormatting($event)"
                  (onContentChanged)="count_Words_Character2()"
                >
                </quill-editor>

                <span
                  class="editSectionDiv"
                  id="placHdlrTxt"
                  spellcheck="false"
                  data-gramm="false"
                  *ngIf="word_count === 0 && char_count === 0 && !editorFocused"
                >
                  {{ "home.Paste-Your-Text" | translate }}
                  <br />
                  &amp; <br />
                  {{ "home.Check-Grammar" | translate }}
                </span>

                <div *ngIf="showError" class="error ms-4">
                  <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                  {{ "home.alert" | translate }}
                </div>
                <span class="icon float-right me-4" *ngIf="char_count !== 0"
                  ><img
                    src="../assets/images/homepage/Trash.svg"
                    class="float-right curs"
                    alt="trash"
                    (click)="deleteText()"
                /></span>
                <span
                  *ngIf="word_count === 0 && char_count === 0"
                  id="chkGramTxtLimit"
                  class="ms-md-4"
                  ><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                  {{ "home.alert" | translate }}</span
                >

                <div class="progress-loader-div">
                  <div class="progress-loader" *ngIf="loaderAlert"></div>
                </div>
                <div id="chkGramBtn" class="w-100 m-0">
                  <div *ngIf="captchaVisible" class="captcha-modal-overlay">
                    <div class="captcha-modal">
                      <div
                        id="recaptcha-container"
                        class="recaptcha-container"
                        data-size="compact"
                        data-theme="light"
                      ></div>
                    </div>
                  </div>

                  <button
                    type="button"
                    (click)="handleButtonClick()"
                    class="btn btn-dark w-100"
                    id="homepagecheckgrammar"
                  >
                    {{ "home.Check-Grammar" | translate }}
                  </button>
                </div>
                <span id="chkGramProcBtn">
                  <button
                    class="btn btn-dark mt-2 w-100 buttonload"
                    (click)="onButtonClick()"
                  >
                    {{ "home.processing" | translate }}
                  </button>
                </span>
              </div>
            </div>
          </div> -->
          <app-lander></app-lander>

          <p class="c simpeTextL mt-4 text-center">
            {{ "home.description" | translate }}
          </p>

          <div *ngIf="profile_id === '1'" class="mat30">
            <div class="social-buttons-div google-login-div">
              <button class="social-buttons d-flex mb-3" (click)="googleLogin()">
                <app-icons-free-tools name="googleicon" class="GoogleImg" />
                <span class="signupGoogle"> {{ "home.signup_google" | translate }} </span>
              </button>
            </div>
            <div class="social-buttons-div text-center">
              <p class="headFontPP mt-2">

                {{ "home.signup_text" | translate }}
                <a href="https://www.grammarin.com/terms-conditions">
                  {{ "home.termAndConditions" | translate }}
                </a>
                {{ "home.And" | translate }}
                <a href="https://www.grammarin.com/privacy-policy">
                  {{ "home.Privacy_Policy" | translate }} </a>
                .
              </p>
            </div>
          </div>

          <div *ngIf="checkLogin" class="mat30 dashbordAfter" style="display: flex; justify-content: center">
            <div>
              <div class="social-buttons-div ">
                <p class="headFontPPDash">
                  {{ "home.access" | translate }} </p>
              </div>
              <div class="social-buttons-div after-login">
                <button class="social-buttons-dash d-flex mb-3 px-3" (click)="navigatetoopenfile()">
                  <app-icons-free-tools name="dashboardhomeicon" class="ms-3 dashboardImg" />

                  <span class="signupDashboard"> {{ "home.GotoDashboard" | translate }} </span>
                </button>
              </div>
            </div>
            <div>
              <img src="../../assets/images/mainHome/gotodashboard.svg" alt="gotodashboard" class="gotodashboard"
                width="36px" height="67px" />
            </div>
          </div>
        </div>

        <div *ngIf="error" class="backdrop"></div>
        <div *ngIf="error" class="content-div">
          <div class="text-center content-div-inner">
            <app-icons-free-tools name="errorIcon" />
            <div class="content-div-p">
              <p class="error-error mt-4">{{ errorAlerts }}</p>
            </div>

            <button class="mt-2 butn-alert" (click)="closeErrorDiv()">
              Ok
            </button>
          </div>
        </div>

        <div *ngIf="success" class="backdrop"></div>
        <div *ngIf="success" class="content-div">
          <div class="text-center content-div-inner">
            <app-icons-free-tools name="successIcon" />
            <p *ngIf="success" class="error mt-4 error-error">
              {{ successAlert }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<section class="home-confident mt-5">
  <div class="container home-confidentCon">
    <div>
      <h2 class="heading mble-screen">{{ "home.Confidently" | translate }}</h2>
      <p class="simpeTextC justify-content-center d-flex padSmall">
        {{ "home.Confidently-detail" | translate }}
      </p>
    </div>
    <div class="home-confident-container mt-5">
      <div class="row">
        <div class="col-lg-6">
          <div class="grammarImgDiv">
            <img [src]="getLocalizedImagePath('choose-grammarIn')" alt="write more illustration" class="grammarImg"
              width="571px" height="571px" />
          </div>
        </div>
        <div class="col-lg-6">
          <div class="grammar-section martop">
            <div class="grammar">
              <a href="https://www.grammarin.com/handbook/grammar">
                {{ "home.GRAMMAR" | translate }}</a>
            </div>
            <h2 class="headingL mt-2">
              {{ "home.WhyChoose" | translate
              }}<span class="greenF"> {{ "home.GrammarIn" | translate }}</span>
            </h2>
            <p class="simpeTextLL mt-4">
              {{ "home.WhyChoose-detail" | translate }}
            </p>

            <div class="grammar-tab">
              <div *ngFor="let feature of grammarFeatures" class="d-flex" style="gap: 0.5rem">
                <app-icons-free-tools name="checkcirclehomeicon" />
                <p>{{ feature | translate }}</p>
              </div>
            </div>
            <a style="text-decoration: none"
              [routerLink]="selectedLanguage.code === 'en' ? '/grammar-checker' : '/' + selectedLanguage.code + '/grammar-checker'">
              <button class="grammar-tab-button mt-3">
                {{ "home.Check-Grammar" | translate }}
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="container my-5">
  <app-premium></app-premium>
</div>

<section class="home-aiAssitant">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 home-aiAssitant-1 martop">
        <div class="aiAssitantText">
          <div class="aiAssitantBtn">
            <div class="aiAssitant">{{ "home.AIASSISTANT" | translate }}</div>
          </div>
          <h2 class="headingLL mt-3">
            {{ "home.Personalized" | translate }} <br />
            <span class="greenF">
              {{ "home.WritingAssistant" | translate }}</span>
          </h2>
          <p class="simpeTextL mt-3 padSmall">
            {{ "home.WritingAssistant-detail" | translate }}
            <a href="https://www.grammarin.com/blog/common-grammar-mistakes-to-avoid/" target="_blank">
              {{ "home.common" | translate }}</a>
            {{ "home.in-writing" | translate }}
          </p>
        </div>
      </div>
      <div class="col-lg-6 home-aiAssitant-2">
        <div class="aiAssitantDiv">
          <img [src]="getLocalizedImagePath('personnalized')" alt="personalized illustration" class="aiAssitantImg"
            width="689px" height="553px" />
        </div>
      </div>
    </div>
  </div>
</section>

<section class="">
  <div class="container home-ultimate">
    <div class="d-flex justify-content-center">
      <div class="academic ulti">{{ "home.UltimateSolution" | translate }}</div>
    </div>

    <div>
      <h2 class="heading mt-3 padSmall phone-view">
        {{ "home.WritingNeeds" | translate }}<br />
        {{ "home.WritingNeedsin" | translate
        }}<span class="greenF"> {{ "home.OnePlace" | translate }}</span>
      </h2>
      <p class="simpeTextC justify-content-center d-flex mt-3 padSmall">
        {{ "home.UltimateSolution-detail" | translate }} <br />
        {{ "home.UltimateSolution-detail2" | translate }}
      </p>
    </div>

    <div class="container">
      <div class="row mt-4">
        <div class="col-lg-3 col-md-3">
          <div class="ultiTab1">
            <div class="">
              <h3 class="ultiTabH">{{ "home.Error-Free" | translate }}</h3>
              <p class="ultiTabP">
                {{ "home.Error-Free-detail" | translate }}
              </p>
            </div>
            <div class="ultiTabimg">
              <img src="../../assets/images/mainHome/Write Error Free Content.webp" alt="Write Error-Free Content"
                width="264px" height="260px" class="ultiImg1" />
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-md-3">
          <div class="ultiTab2 ultiMar">
            <div class="ultiTabimg">
              <img src="../../assets/images/mainHome/Write with Fluency.webp" alt="Write with Fluency" width="264px"
                height="260px" class="ultiImg2" />
            </div>
            <div class="">
              <h3 class="ultiTabH ultiMar">{{ "home.Fluency" | translate }}</h3>
              <p class="ultiTabP">
                {{ "home.Fluency-detail" | translate }}
                <a href="https://www.grammarin.com/sentence-checker">
                  {{ "home.Fluency-a" | translate }}</a>
                {{ "home.Fluency-detail2" | translate }}
              </p>
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-md-3">
          <div class="ultiTab3 ultiMar">
            <div class="">
              <h3 class="ultiTabH">{{ "home.WritingTone" | translate }}</h3>
              <p class="ultiTabP">
                {{ "home.WritingTone-detail" | translate }}
              </p>
            </div>
            <div class="ultiTabimg">
              <img src="../../assets/images/mainHome/Set Up Writing Tone.webp" alt="Set Up Writing Tone" width="264px"
                height="260px" class="ultiImg3" />
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-md-3">
          <div class="ultiTab4 ultiMar">
            <div class="ultiTabimg">
              <img src="../../assets/images/mainHome/Insightful Reports.webp" alt="Insightful Reports" width="264px"
                height="260px" class="ultiImg2" />
            </div>
            <div class="">
              <h3 class="ultiTabH ultiMar">
                {{ "home.InsightfulReports" | translate }}
              </h3>
              <p class="ultiTabP">
                {{ "home.InsightfulReports-detail" | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="home-academic">
  <div class="container home-academicCon">
    <div class="d-flex justify-content-center">
      <div class="academic">{{ "home.ACADEMICWRITING" | translate }}</div>
    </div>

    <div>
      <h2 class="heading mt-3 padSmall phone-view">
        {{ "home.UltimateAcademic" | translate }}
        <span class="greenF">{{ "home.WritingSolution" | translate }}</span>
      </h2>
      <p class="simpeTextC justify-content-center d-flex mt-3 padSmall">
        {{ "home.ACADEMICWRITING-detail" | translate }}
      </p>
    </div>

    <div class="container">
      <div class="row mt-4">
        <div class="col-lg-4">
          <div class="keyFeatureTab">
            <div class="keytabImg">
              <app-icons-free-tools name="Subjectverbagreementhomeicon" />
            </div>
            <div class="marleft">
              <h3>{{ "home.Subjectverb" | translate }}</h3>
              <p>
                {{ "home.Subjectverb-detail" | translate }}
                <a href="https://www.grammarin.com/what-is-a-verb">
                  {{ "home.singular_verb" | translate }}
                </a>
                {{ "home.is_goes" | translate }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-4 martop">
          <div class="keyFeatureTab">
            <div class="keytabImg">
              <app-icons-free-tools name="SingularPluralnounshomeicon" />
            </div>
            <div class="marleft">
              <h3>{{ "home.Singular" | translate }}</h3>
              <p>
                {{ "home.Singular-detail" | translate }}
                <a href="https://www.grammarin.com/what-are-nouns">
                  {{ "home.plural_noun" | translate }}</a>
                {{ "home.Singular-detail_2" | translate }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-4 martop">
          <div class="keyFeatureTab">
            <div class="keytabImg">
              <app-icons-free-tools name="Compoundnounshomeicon" />
            </div>
            <div class="marleft">
              <h3>{{ "home.Compoundnouns" | translate }}</h3>
              <p>
                {{ "home.Compoundnouns-detail" | translate }}
                <a href="https://www.grammarin.com/what-are-compound-words">
                  {{ "home.compound" | translate }}</a>
                {{ "home.is-a-noun" | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-lg-4">
          <div class="keyFeatureTab">
            <div class="keytabImg">
              <app-icons-free-tools name="Collocationhomeicon" />
            </div>
            <div class="marleft">
              <h3>{{ "home.Collocation" | translate }}</h3>
              <p>
                A {{ "home.a" | translate }}
                <a href="https://www.grammarin.com/what-are-collocations">
                  {{ "home.collocation" | translate }}
                </a>
                {{ "home.Collocation-detail" | translate }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-4 martop">
          <div class="keyFeatureTab">
            <div class="keytabImg">
              <app-icons-free-tools name="Wordorderhomeicon" />
            </div>
            <div class="marleft">
              <h3>{{ "home.Wordorder" | translate }}</h3>
              <p>
                {{ "home.Regarding" | translate }}
                <a href="https://www.grammarin.com/blog/what-is-word-order/" target="_blank">
                  {{ "home.word_order" | translate }}
                </a>
                {{ "home.Wordorder-detail" | translate }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-4 martop">
          <div class="keyFeatureTab">
            <div class="keytabImg">
              <app-icons-free-tools name="Contextualwordcorrectionhomeicon" />
            </div>
            <div class="marleft">
              <h3>{{ "home.Contextualword" | translate }}</h3>
              <p>
                {{ "home.Contextualword-detail" | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="home-beneficiaries">
  <div class="conatainer home-beneficiariesCont">
    <div class="d-flex justify-content-center">
      <div class="aibased">{{ "home.AIBASEDTOOLS" | translate }}</div>
    </div>
    <div>
      <h2 class="heading mt-3 padSmall home-beneficiariesM" id="">
        {{ "home.Beneficiaries" | translate }}
        <span class="greenF"> {{ "home.BasedTools" | translate }} </span>
      </h2>
      <p class="heading mt-3 padSmall home-beneficiariesSmall" id="">
        {{ "home.Beneficiaries" | translate }} <br />
        <span class="greenF"> {{ "home.BasedTools" | translate }} </span>
      </p>
      <p class="simpeTextC justify-content-center d-flex mt-3 padSmall">
        {{ "home.BasedTools-detail" | translate }}
        <a [routerLink]="selectedLanguage.code === 'en' ? '/grammar-checker' : '/' + selectedLanguage.code + '/grammar-checker'"
          class="gramTag greenF">
          {{ "home.BasedTools-a" | translate }}
        </a>
        {{ "home.BasedTools-detail2" | translate }} <br />
        {{ "home.BasedTools-detail22" | translate }}
      </p>
    </div>

    <div class="container d-flex justify-content-center">
      <img [src]="getLocalizedImagePath('beneficiaries-home')" alt="beneficiaries of - illustration" width="1311px"
        height="687px" class="home-beneficiariesIMG" />
    </div>
  </div>
</section>

<section class="home-smartAssistant">
  <div class="container smartAssistant">
    <div class="d-flex justify-content-center">
      <div class="smartAlter">{{ "home.SmartAlternatives" | translate }}</div>
    </div>
    <div>
      <h2 class="heading mt-3 padSmall">
        {{ "home.Grammatically" | translate }} <br />
        {{ "home.Grammatically2" | translate }}
        <span class="greenF"> {{ "home.Alternatives" | translate }}</span>
      </h2>
      <p class="simpeTextC justify-content-center d-flex mt-3 padSmall">
        {{ "home.SmartAlternatives-detail" | translate }} <br />
        {{ "home.SmartAlternatives-detail2" | translate }} <br />
        {{ "home.SmartAlternatives-detail3" | translate }}
      </p>
    </div>

    <div class="smartAssistantInner">
      <div class="row">
        <div class="col-lg-6 mt-2">
          <div class="smartAssistantTab">
            <div>
              <app-icons-free-tools name="BringsClarityhomeicon" />
            </div>
            <div class="marleft">
              <h3 class="martoppp">
                {{ "home.BringsClarity" | translate }}
              </h3>
              <p>
                {{ "home.BringsClarity-detail" | translate }}
              </p>
            </div>
          </div>
          <div class="mt-4 smartAssistantTab">
            <div>
              <app-icons-free-tools name="ContextualSynonymshomeicon" />
            </div>
            <div class="marleft">
              <h3 class="martoppp">
                {{ "home.ContextualSynonyms" | translate }}
              </h3>
              <p>
                {{ "home.ContextualSynonyms-detail" | translate }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-6" id="carousel-img">
          <div id="GramPlag_carousel" class="carousel slide d-inline-block" data-ride="carousel">
            <div class="carousel-inner">
              <div class="carousel-item active">
                <div class="col-12 float-left w-100 d-inline-block p-0">
                  <img class="img-fluid" [src]="getLocalizedImagePath('brings-clarity')" alt="bring clarity"
                    width="640px" height="360px" />
                </div>
              </div>
              <div class="carousel-item">
                <div class="col-12 float-left w-100 d-inline-block p-0">
                  <img class="img-fluid" [src]="getLocalizedImagePath('contextual-synonyms')" alt="contextual"
                    width="640px" height="360px" />
                </div>
              </div>
            </div>

            <ol class="carousel-indicators c_indi_banner">
              <li data-target="#GramPlag_carousel" data-slide-to="0" class="active"></li>
              <li data-target="#GramPlag_carousel" data-slide-to="1"></li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- captcha for form submit  -->
<div *ngIf="captchaVisible" class="captcha-modal-overlay">
  <div class="captcha-modal">
    <div id="recaptcha-container" class="recaptcha-container" data-size="compact" data-theme="light"></div>
  </div>
</div>
<!-- captcha for form submit  -->
<section class="getinTouch">
  <div class="container getinTouch-section">
    <div class="row">
      <div class="col-lg-6 col-12 getinTouch-section1 martop">
        <div class="getinTouch-section1Text">
          <h2 class="headingL">{{ "home.GetinTouch" | translate }}</h2>
          <p class="simpeTextLL">
            {{ "home.GetinTouch-detail" | translate }}
          </p>
        </div>

        <div class="info-section mb-4">
          <div class="contactTabsA">
            <div class="mIMG">
              <app-icons-free-tools name="chattouchhomeicon" />
            </div>
            <p class="ml-4">
              {{ "home.message" | translate }}
            </p>
          </div>
        </div>
        <div class="info-section mb-3">
          <div class="contactTabsA">
            <div class="mIMG">
              <app-icons-free-tools name="clocktouchhomeicon" />
            </div>
            <p class="ml-4">
              {{ "home.support" | translate }}
            </p>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-12 getinTouch-section2">
        <div class="getinTouch-section2Text">
          <p class="headingL">{{ "home.GetinTouch" | translate }}</p>
          <p class="simpeTextLL">
            {{ "home.GetinTouch-detail" | translate }}
          </p>
        </div>

        <p class="text-left success-msg" *ngIf="got_recpatcha" [ngStyle]="{
            color: color,
            'background-color': '#f8d7da',
            padding: '2px'
          }">
          <i class="fa fa-times-circle matr ml-1" aria-hidden="true"></i>
          {{ recaptcha_message }}
        </p>
        <form>
          <div class="h20 mt-0">
            <p class="text-left success-alter" id="eFsubText" [ngStyle]="{ color: color }" *ngIf="eFsub">
              <i class="fas fa-check-circle matr ml-1" aria-hidden="true"></i>
              {{ eFsubText }}
            </p>
            <p class="text-left alert-danger" id="eFsubTexterror" [ngStyle]="{ color: color }" *ngIf="eFsuberror">
              <i class="fa fa-times-circle matr ml-1" aria-hidden="true"></i>
              {{ eFsubText }}
            </p>
          </div>

          <div class="row mb-2 mt-3">
            <div class="col-md-6">
              <label for="firstName" class="form-label name mt-2">
                {{ "home.FirstName" | translate }}</label>
              <input id="form_name" type="text" name="form_name" class="form-control h50 bd-light" value="" />
            </div>
            <div class="col-md-6">
              <label for="lastName" class="form-label mt-2">
                {{ "home.LastName" | translate }}</label>
              <input id="form_lastname" type="text" name="form_lastname" class="form-control h50 bd-light" value="" />
            </div>
          </div>
          <div class="mb-2">
            <label for="email" class="form-label">
              {{ "home.Email" | translate }}</label>
            <input id="form_emailget" type="email" name="form_emailget" class="form-control h50 bd-light" value="" />
          </div>
          <div class="mb-4">
            <label for="message" class="form-label">
              {{ "home.Message" | translate }}</label>
            <textarea id="form_messageget" name="form_messageget" class="form-control bd-light" data-gramm="false"
              spellcheck="false"></textarea>
          </div>

          <button type="submit" class="btn w-100 eSubmitForm" (click)="handleButtonClickGetTouch()">
            {{ "home.Submit" | translate }}
          </button>
        </form>
      </div>
    </div>
  </div>
</section>
<div class="modal fade" data-backdrop="static" data-keyboard="false" id="tooltiphomeButtonModalbefore"
  #tooltiphomeButtonModalbefore tabindex="-1" role="dialog" aria-labelledby="tooltiphomeButtonModalbefore"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content modal-content-custom"></div>
  </div>
</div>

<app-feedback></app-feedback>


<app-premium-modal-startup />

<app-footer></app-footer>